<template>
    <div class="badges-container">
        <div class="badges-grid" :style="{'--badge-max': size + 'px'}">
            <v-img
                v-for="badge in badges"
                :key="badge"
                class="badges-grid__icon"
                :src="require(`@/assets/pic/badge/${badge}.png`)"
                contain
                @click="$emit('badge-click', badge)"
            />
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    // import {API_ENTRYPOINT} from "@/config/entrypoint";

    export default {
        components: {},
        props: {
          badges: {Array, default: []},
          size: {Number, default: 50},
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
            }),
        },
        created() {
        },
        methods: {
            ...mapActions({
            }),
        },
    }
</script>

<style scoped>
    .badges-container {
        container-type: inline-size;
        width: 100%;
    }

    /* column-width (ne pevny column-count) se sam prizpusobi sirce kontejneru - viz claude/components/trainer.md */
    .badges-grid {
        column-width: calc(var(--badge-max, 80px) + 10px);
        column-gap: 8px;
        padding: 8px;
    }

    .badges-grid__icon {
        width: clamp(36px, 16cqi, var(--badge-max, 80px));
        height: clamp(36px, 16cqi, var(--badge-max, 80px));
        margin: 0 0 8px;
        break-inside: avoid;
        cursor: pointer;
    }
</style>
